import React, { Fragment, useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import DataTable from "react-data-table-component";
import Loader from "../Loader/Loader";
import axios from "axios";
import config from "../../config/config";
import { toastSuccess, toastError } from "../../common/Toast";
import {
  DELETE_MESSAGE,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_ITEMS,
} from "../../common/Constant";
// import { async } from "q";

function Offers({ searchQuery }) {
  const [visibleOffers, setVisibleOffers] = useState(false);

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("Token");
  // const [commonConfig, setCommonConfig] = useState(0);

  // Form Values
  const [formValues, setFormValues] = useState({
    Number: "",
    Address: "",
    Email: "",
    FacebookLink: "",
    TwitterLink: "",
    GoogleLink: "",
    InstaLink: "",
  });
  // Form Values

  //TableData Columns
  const columns = [
    {
      name: "Title",
      selector: "Title",
      sortable: true,
      width: "100px",
    },
    {
      name: "Description",
      selector: "Description",
      sortable: true,
      width: "190px",
    },
    {
      name: "ButtonName",
      selector: "ButtonName",
      sortable: true,
      width: "150px",
    },
    {
      name: "LinkToRedirect",
      selector: "LinkToRedirect",
      sortable: true,
      width: "200px",
    },
    {
      name: "Images",
      selector: "Images",
      sortable: true,
      cell: (row) => (
        <>
          <div
            className="form-control d-flex flex-wrap "
            style={{ backgroundColor: "-moz-initial" }}
          >
            {row.Images.map((image, index) => (
              <img
                key={index}
                src={image}
                className="mx-2 my-1"
                style={{
                  maxWidth: "auto",
                  maxHeight: "50px",
                }}
                alt={`Selected Image ${index}`}
              />
            ))}
          </div>
        </>
      ),
    },
  ];
  //TableData Columns

  //HandleSubmit For the Form
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      Number: formValues.Number,
      Address: formValues.Address,
      Email: formValues.Email,
      FacebookLink: formValues.FacebookLink,
      TwitterLink: formValues.TwitterLink,
      GoogleLink: formValues.GoogleLink,
      InstaLink: formValues.InstaLink,
    };
    setLoading(true);
    axios
      .post(`${config.ecommconfigBaseUrl}/ecomconfig/contactusupsert`, data, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          // navigate("/suppliers");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError("Email" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
      });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
  };

  async function getContactDetails() {
    await axios
      .get(
        `${config.ecommconfigBaseUrl}/ecomconfig/commonconfigvalues?configtype=ContactUs`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // setCommonConfig(res.data.ResponseData);

        const address = res.data.ResponseData.filter(
          (item) => item.CommonConfigKey === "Address"
        );

        const number = res.data.ResponseData.filter(
          (item) => item.CommonConfigKey === "Number"
        );

        const email = res.data.ResponseData.filter(
          (item) => item.CommonConfigKey === "Email"
        );

        const facebookLink = res.data.ResponseData.filter(
          (item) => item.CommonConfigKey === "FacebookLink"
        );

        const twitterLink = res.data.ResponseData.filter(
          (item) => item.CommonConfigKey === "TwitterLink"
        );

        const googleLink = res.data.ResponseData.filter(
          (item) => item.CommonConfigKey === "GoogleLink"
        );

        const instagramLink = res.data.ResponseData.filter(
          (item) => item.CommonConfigKey === "InstagramLink"
        );

        const data = {
          Number: number[0].CommonConfigValue,
          Address: address[0].CommonConfigValue,
          Email: email[0].CommonConfigValue,
          FacebookLink: facebookLink[0].CommonConfigValue,
          TwitterLink: twitterLink[0].CommonConfigValue,
          GoogleLink: googleLink[0].CommonConfigValue,
          InstaLink: instagramLink[0].CommonConfigValue,
        };

        setFormValues(data);
      })
      .catch((err) => {});
  }

  useEffect(() => {
    getContactDetails();
  }, []);

  const data = [
    {
      name: "Number",
      input: (
        <>
          <input
            width="350px"
            className="form-control"
            placeholder="Enter Number Here"
            name="Number"
            onChange={handleChange}
            value={formValues.Number}
          />
        </>
      ),
    },
    {
      name: "Address",
      input: (
        <>
          <input
            width="350px"
            className="form-control"
            placeholder="Enter Address"
            name="Address"
            onChange={handleChange}
            value={formValues.Address}
          />
        </>
      ),
    },
    {
      name: "Email",
      input: (
        <>
          {" "}
          <input
            width="350px"
            className="form-control"
            placeholder="Enter Email Here"
            name="Email"
            onChange={handleChange}
            value={formValues.Email}
          />
        </>
      ),
    },
    {
      name: "FB Link",
      input: (
        <>
          {" "}
          <input
            width="350px"
            className="form-control"
            placeholder="Enter Button Name"
            name="FacebookLink"
            onChange={handleChange}
            value={formValues.FacebookLink}
          />
        </>
      ),
    },
    {
      name: "Twitter Link",
      input: (
        <>
          {" "}
          <input
            width="350px"
            className="form-control"
            placeholder="Enter Twitter Link"
            name="TwitterLink"
            onChange={handleChange}
            value={formValues.TwitterLink}
          />
        </>
      ),
    },
    {
      name: "Google Link",
      input: (
        <>
          {" "}
          <input
            width="350px"
            className="form-control"
            placeholder="Enter Google Link"
            name="GoogleLink"
            onChange={handleChange}
            value={formValues.GoogleLink}
          />
        </>
      ),
    },
    {
      name: "Insta Link",
      input: (
        <>
          <input
            width="350px"
            className="form-control"
            placeholder="Enter Insta Link"
            name="InstaLink"
            onChange={handleChange}
            value={formValues.InstaLink}
          />
        </>
      ),
    },
  ];

  const matchesSearchQuery = data.filter((el) => {
    return el.name.toLowerCase().includes(searchQuery.toLowerCase());
  });

  return (
    <Fragment>
      {matchesSearchQuery.length === data.length ? (
        <div className="card">
          <div className="card-header">
            <h5 className="card-title">
              <CLink
                className="link"
                onClick={() => setVisibleOffers(!visibleOffers)}
              >
                Contact Us
              </CLink>
            </h5>
          </div>
          <CCollapse visible={visibleOffers}>
            <div className="card-body">
              {formValues && (
                <>
                  <form onSubmit={handleSubmit}>
                    <div
                      className="container"
                      style={{
                        textAlign: "center",
                        // backgroundColor: "blanchedalmond",
                        border: "1px solid rgba(0,0,0,.12)",
                      }}
                    >
                      <div className="row mb-3 pt-3">
                        <div className="col-md-12">
                          <div className="row">
                            <div
                              // className="col-md-2"
                              style={{
                                width: "100%",
                                display: "grid",
                                gridTemplateColumns: "repeat(2,1fr)",
                                gap: "10px",
                                textAlign: "left",
                              }}
                            >
                              {matchesSearchQuery &&
                                matchesSearchQuery?.map((el) => {
                                  return (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "left",
                                      }}
                                    >
                                      <label
                                        className="mt-1 pull-left w-50"
                                        style={{ fontSize: "15px" }}
                                      >
                                        {el.name}
                                      </label>
                                      <div className="col-md-10 text-left">
                                        {el.input}
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                            <div className="col-md-10"></div>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex justify-content-center mt-3">
                        <button type="submit" className="btn btn-primary mb-3">
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </>
              )}
            </div>
          </CCollapse>
        </div>
      ) : (
        matchesSearchQuery.length !== 0 && (
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                <CLink
                  className="link"
                  onClick={() => setVisibleOffers(!visibleOffers)}
                >
                  Contact Us
                </CLink>
              </h5>
            </div>
            <CCollapse visible={visibleOffers}>
              <div className="card-body">
                {formValues && (
                  <>
                    <form onSubmit={handleSubmit}>
                      <div
                        className="container"
                        style={{
                          textAlign: "center",
                          // backgroundColor: "blanchedalmond",
                          border: "1px solid rgba(0,0,0,.12)",
                        }}
                      >
                        <div className="row mb-3 pt-3">
                          <div className="col-md-6">
                            <div className="row">
                              <div
                                // className="col-md-2"
                                style={{
                                  width: "100%",
                                  display: "grid",
                                  gridTemplateColumns: "repeat(2,1fr)",
                                  gap: "10px",
                                }}
                              >
                                {matchesSearchQuery &&
                                  matchesSearchQuery?.map((el) => {
                                    return (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <label
                                          className="mt-1 pull-left w-50"
                                          style={{ fontSize: "15px" }}
                                        >
                                          {el.name}
                                        </label>
                                        <div className="col-md-10 text-left">
                                          {el.input}
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                              <div className="col-md-10"></div>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex justify-content-center mt-3">
                          <button
                            type="submit"
                            className="btn btn-primary mb-3"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </>
                )}
              </div>
            </CCollapse>
          </div>
        )
      )}
    </Fragment>
  );
}

export default Offers;
